import { render, staticRenderFns } from "./AddQualificationDialog.vue?vue&type=template&id=2b1e6a24&"
import script from "./AddQualificationDialog.vue?vue&type=script&lang=js&"
export * from "./AddQualificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports